export default __webpack_public_path__ + "static/media/background-allovoisins.7b027ba9.jpg";